import React from 'react';
import Select from 'react-select';

import { ModifierGroup } from 'src/apollo/onlineOrdering';

import { PriceLine } from 'public/components/default_template/menu_section/MenuItemCard';
import { MenuItem } from 'public/components/default_template/menu_section/MenuSection';
import QuantitySelector from 'public/components/default_template/online_ordering/item_modal/QuantitySelector';
import { MenuItemImage } from 'public/components/default_template/product_display/MenuItemImage';

type Props = {
  menuItem: MenuItem
  modifierGroups: ModifierGroup[]
}

export const ProductDisplay = ({ menuItem, modifierGroups }: Props) => {
  return (
    <div className="paddedSection productDisplaySection">
      {menuItem?.imageUrls &&
        <div className="productImageSection">
          <MenuItemImage item={menuItem} />
        </div>}
      <div className="productInfoSection">
        <h2 className="productNameRow">{menuItem.name}</h2>

        {/* TODO show offer price */}
        {/* TODO price doesn't show since menuItemDetails and useOOMenus return different types */}
        <div className="pricesRow">
          <PriceLine item={menuItem} />
        </div>

        <Modifiers groups={modifierGroups} />

        <div className="addToCartRow">
          <AddToCart />
          <QuantitySelector min={1} canIncrease={true} onQuantityChange={() => {}} />
        </div>
        <div>
          {menuItem.description}
        </div>
      </div>
    </div>
  );
};

const AddToCart = () => {
  return (
    <button
      type="button"
      className="modalButton addToCartButton" style={{ justifyContent: 'center' }}>
        Add to Cart
    </button>
  );
};

const Modifiers = ({ groups }: { groups: ModifierGroup[] }) => {
  return (
    <div>
      {groups?.map((group: ModifierGroup) =>
        <div key={group.guid} className="modifierGroupRow">
          <label>
            <h3>{group.name}</h3>
            <Select
              classNamePrefix="react-select"
              isClearable
              isSearchable={false}
              required={!!group.minSelections}
              isMulti={group.maxSelections === null}
              menuPosition="fixed"
              options={group.modifiers.map(modifier =>
                ({ value: modifier.itemGuid, label: modifier.name || '' }))} />
          </label>
        </div>)}
    </div>
  );
};
